"use client";

import React from "react";
import { ArrowRight, Star, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 1,
  status: "publish"
};
const wp_query = new WP_Query(wp_query_params);
function HeroConsumer() {
  const {
    products,
    loading
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="3236" className="container mx-auto px-6 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8 animate-pulse">
            <div className="h-20 bg-primary/10 rounded-xl w-3/4"></div>
            <div className="h-8 bg-primary/5 rounded-lg w-1/2"></div>
            <div className="flex gap-4 pt-4">
              <div className="h-12 w-40 bg-primary/20 rounded-full"></div>
              <div className="h-12 w-32 bg-primary/10 rounded-full"></div>
            </div>
          </div>
          <div className="hidden lg:block h-[600px] bg-muted/20 rounded-3xl animate-pulse"></div>
        </div>
      </div>;
  }
  const product = products[0];
  const productId = product?.id;
  return <div className="container mx-auto px-6 py-20 lg:py-32 relative z-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        
        {}
        <div className="lg:col-span-6 flex flex-col justify-center text-center lg:text-left space-y-8 lg:space-y-10">
          
          {}
          <div className="flex items-center justify-center lg:justify-start gap-2 text-xs font-bold tracking-widest text-primary uppercase">
            <div className="flex text-primary">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
            </div>
            <span>Join 10,000+ Students in Toronto</span>
          </div>

          {}
          <h1 className="text-6xl lg:text-8xl font-sans font-black leading-[0.95] text-foreground tracking-tighter uppercase">
            Join the <span className="text-primary">HalfOrder</span> Network
          </h1>

          {}
          <p className="text-lg lg:text-xl text-muted-foreground font-sans leading-relaxed max-w-2xl mx-auto lg:mx-0">
            The smartest way to split meals and save money. Connect with students nearby and share your favorite Toronto eats today.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-5 pt-4">
            {productId ? <div className="w-full sm:w-auto">
                <AddToCartButton productId={productId} variant="default" text="Download the App" className="w-full sm:w-auto" buttonClassName="h-14 px-8 rounded bg-primary text-primary-foreground text-lg font-bold uppercase tracking-tight shadow-xl shadow-primary/20 hover:shadow-primary/30 hover:bg-primary/90 transition-all duration-300 transform hover:-translate-y-0.5" showQuantity={false} />
              </div> : <Button size="lg" className="h-14 px-8 rounded bg-primary text-primary-foreground text-lg font-bold uppercase tracking-tight shadow-xl shadow-primary/20 hover:shadow-primary/30 hover:bg-primary/90 transition-all duration-300 transform hover:-translate-y-0.5">
                Download the App
              </Button>}
            
            <Link to="/HowItWorksPage" className="group flex items-center gap-2 text-lg font-bold uppercase tracking-tight text-foreground/80 hover:text-primary transition-colors px-4 py-2">
              How it Works
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          {}
          <div className="pt-8 flex flex-wrap justify-center lg:justify-start gap-x-8 gap-y-3 text-sm font-medium text-muted-foreground/90 uppercase tracking-wider">
            <div className="flex items-center gap-2">
              <CircleCheck className="w-4 h-4 text-primary" />
              <span>Real-time Matching</span>
            </div>
            <div className="flex items-center gap-2">
              <CircleCheck className="w-4 h-4 text-primary" />
              <span>Instant Splitting</span>
            </div>
            <div className="flex items-center gap-2">
              <CircleCheck className="w-4 h-4 text-primary" />
              <span>Toronto Exclusive</span>
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-6 relative h-[500px] lg:h-[700px] w-full flex items-center justify-center perspective-[2000px]">
          {}
          <div className="absolute inset-0 bg-gradient-to-tr from-primary/30 via-transparent to-transparent rounded-full blur-3xl opacity-60 transform translate-x-10 translate-y-10"></div>

          {}
          <div className="relative w-[300px] sm:w-[380px] aspect-[1/1.4] transform-style-3d rotate-y-[-15deg] rotate-x-[10deg] hover:rotate-y-[-5deg] hover:rotate-x-[5deg] transition-transform duration-700 ease-out cursor-pointer group">
            
            {}
            <div className="absolute inset-0 bg-card rounded-lg shadow-2xl transform translate-x-12 -translate-y-12 rotate-[6deg] group-hover:translate-x-16 group-hover:-translate-y-16 group-hover:rotate-[8deg] transition-all duration-500 border border-primary/10 overflow-hidden">
               <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/qr_ios_orange.png" alt="iOS Download QR Code" className="w-full h-full object-cover opacity-95" />
            </div>

            {}
            <div className="absolute inset-0 bg-card rounded-lg shadow-2xl transform translate-x-6 -translate-y-6 rotate-[3deg] group-hover:translate-x-8 group-hover:-translate-y-8 group-hover:rotate-[4deg] transition-all duration-500 border border-primary/10 overflow-hidden">
               <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/qr_android_orange.png" alt="Android Download QR Code" className="w-full h-full object-cover opacity-95" />
            </div>

            {}
            <div className="absolute inset-0 bg-card rounded-lg shadow-xl shadow-primary/20 transform transition-all duration-500 border border-primary/10 overflow-hidden z-10">
               <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/halforder_app_mockup.png" alt="HalfOrder App Interface" className="w-full h-full object-cover" />
               {}
               <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
            </div>

            {}
            <div className="absolute -bottom-6 -right-6 z-20 bg-card/90 backdrop-blur-md border border-primary/20 shadow-lg rounded-full p-4 flex flex-col items-center justify-center w-24 h-24 animate-bounce">
              <span className="text-2xl font-black text-primary">50%</span>
              <span className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">OFF</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export default function PremiumEditorialEntrance() {
  return <section id="join-the-network" className="relative w-full overflow-hidden bg-background dark text-foreground">
      {}
      <div className="absolute inset-0 pointer-events-none">
        {}
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,var(--color-primary)_0%,transparent_60%)] opacity-20"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-[radial-gradient(circle_at_20%_80%,var(--color-primary)_0%,transparent_40%)] opacity-10"></div>
        
        {}
        <div className="absolute inset-0 opacity-[0.03] bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/noise_texture.png')] mix-blend-overlay"></div>
      </div>

      <EcommerceProductsProvider wp_query={{
      per_page: 1,
      status: ["publish"]
    }} postType="product" className="w-full">
        <HeroConsumer />
      </EcommerceProductsProvider>
    </section>;
}